module.exports = __webpack_public_path__ + "static/media/RS.590e1df3.png";